/* eslint-disable no-magic-numbers */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { createRef } from 'react';

import Image from 'Component/Image';
import MenuItem from 'Component/MenuItem';
import { Menu as SourceMenu } from 'SourceComponent/Menu/Menu.component';
import CSS from 'Util/CSS';
import { getSortedItems } from 'Util/Menu';

import './Menu.style';
import './Menu.extended.style';

/** @namespace Scandipwa/Component/Menu/Component */
export class MenuComponent extends SourceMenu {
    static propTypes = {
        ...super.propTypes,
        onCategoryClick: PropTypes.func,
        isLoading: PropTypes.bool.isRequired
    };

    static defaultProps = {
        onCategoryClick: () => {}
    };

    state = {
        hoveredMenuItem: undefined,
        hoveredParent: undefined,
        activeItem: undefined,
        prevActiveItem: undefined,
        animationIndex: 1
    };

    submenuWrapperRef = createRef();

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(_prevProps, prevState) {
        const { hoveredParent } = this.state;
        const { hoveredParent: prevHoveredParent } = prevState;

        if (hoveredParent !== prevHoveredParent) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ activeItem: undefined, prevActiveItem: undefined });
        }

        if (this.submenuWrapperRef && this.submenuWrapperRef.current) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.handleResize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        CSS.setVariable(
            this.submenuWrapperRef,
            'sumbenu-wrapper-width',
            `${document.body.clientWidth}px`
        );
    };

    getKey = (item) => {
        const { animationIndex } = this.state;
        return animationIndex * item.item_id;
    };

    handleSliderItemHover = (item) => {
        if (!item.category_image) {
            return null;
        }

        this.setState((prevState) => ({
            ...prevState,
            prevActiveItem: prevState.activeItem,
            activeItem: item,
            animationIndex: prevState.animationIndex * (-1)
        }));

        return null;
    };

    renderPrevImage() {
        const { prevActiveItem } = this.state;

        if (!prevActiveItem) {
            return null;
        }

        return (
            <div block="Menu" elem="ImagePrev">
                <Image
                  src={ prevActiveItem.category_image }
                  key={ this.getKey(prevActiveItem) }
                  ratio="custom"
                  mix={ {
                      block: 'ImagePrevAnimation'
                  } }
                />
            </div>
        );
    }

    renderCurrentImage() {
        const { activeItem } = this.state;

        if (!activeItem) {
            return null;
        }

        return (
            <div block="Menu" elem="ImageCurrent">
                <Image
                  src={ activeItem.category_image }
                  key={ this.getKey(activeItem) }
                  ratio="custom"
                  mix={ {
                      block: 'ImageCurrentAnimation'
                  } }
                />
            </div>
        );
    }

    renderImagesContainer() {
        return (
            <div block="Menu" elem="ImagesContainer">
                { this.renderPrevImage() }
                { this.renderCurrentImage() }
            </div>
        );
    }

    renderDesktopSubLevelItems(item, mods) {
        const { item_id, item_class } = item;
        const { closeMenu, activeMenuItemsStack } = this.props;

        const isSale = item_class.includes('MenuItem-Sale');
        const isMobileOnly = item_class.split(' ').includes('mobile-only');
        const itemMods = {
            ...mods,
            isSale
        };

        if (isMobileOnly) {
            return null;
        }

        return (
            <MenuItem
              activeMenuItemsStack={ activeMenuItemsStack }
              item={ item }
              itemMods={ itemMods }
              closeMenu={ closeMenu }
              isLink
              key={ item_id }
              isDeviceDesktop
              handleSliderItemHover={ this.handleSliderItemHover }
            />
        );
    }

    renderDesktopSubLevel(category) {
        const { children, item_class, item_id } = category;
        const childrenArray = getSortedItems(Object.values(children));

        if (!childrenArray.length) {
            return null;
        }

        const isBanner = item_class === 'Menu-ItemFigure_type_banner';
        const isLogo = item_class === 'Menu-ItemFigure_type_logo';
        const mods = {
            isBanner: !!isBanner,
            isLogo: !!isLogo
        };

        const customGroup = {
            isDefined: false,
            name: ''
        };

        return (
            <div
              block="Menu"
              elem="SubLevelDesktop"
              key={ item_id }
            >
                <div
                  block="Menu"
                  elem="ItemList"
                  mods={ { ...mods } }
                >
                    { childrenArray.map((item) => {
                        const configurations = item.item_class.split(' ');

                        if (configurations.includes('custom-group')) {
                            customGroup.isDefined = true;
                            customGroup.name = configurations[1].replace(/-/g, ' ');
                        } else {
                            return this.renderDesktopSubLevelItems(item, mods);
                        }

                        return null;
                    }) }

                    { customGroup.isDefined && (
                        <div block="Menu" elem="CustomGroupTitle">{ customGroup.name }</div>
                    ) }
                    { childrenArray.map((item) => {
                        const configurations = item.item_class.split(' ');

                        if (configurations.includes('custom-group')) {
                            return this.renderDesktopSubLevelItems(item, mods);
                        }

                        return null;
                    }) }
                </div>
            </div>
        );
    }

    onMouseEnter = ({ item_id, item_class }) => {
        if (!item_class.split(' ').includes('promotional')) {
            this.setState({ hoveredMenuItem: item_id });
        }
    };

    onMouseLeave = () => {
        this.setState({ hoveredMenuItem: undefined });
    };

    renderSubLevelItems = (item) => {
        const {
            activeMenuItemsStack,
            closeMenu
        } = this.props;

        const {
            item_id,
            item_class
        } = item;

        const { hoveredMenuItem } = this.state;

        const isHidden = item_class.split(' ').includes('hidden');
        const isMobileOnly = item_class.split(' ').includes('mobile-only');
        const mods = { isHidden, isSubCategory: true };

        if (isMobileOnly) {
            return null;
        }

        return (
            <div
              block="Menu"
              elem="SubItemWrapper"
              key={ item_id }
              mods={ { isHover: hoveredMenuItem === item_id, isHidden } }
              onMouseEnter={ () => this.onMouseEnter(item) }
              onMouseLeave={ this.onMouseLeave }
            >
                <MenuItem
                  activeMenuItemsStack={ activeMenuItemsStack }
                  itemMods={ mods }
                  item={ item }
                  closeMenu={ closeMenu }
                  isLink
                  isHighlighted={ item_class.split(' ').includes('highlight') }
                  isDeviceDesktop
                />
                { this.renderDesktopSubLevel(item) }
            </div>
        );
    };

    renderSubLevel(category) {
        const { activeMenuItemsStack } = this.props;
        const { item_id, children } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        const { hoveredMenuItem } = this.state;

        const customData = {
            isCustomGroup: false,
            isPromotional: false,
            customGroupName: ''
        };

        return (
            <div
              block="Menu"
              elem="SubMenu"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menu"
                  elem="ItemList"
                  mods={ { ...subcategoryMods, isHover: !!hoveredMenuItem } }
                >
                    { childrenArray.map((item) => {
                        const configurations = item.item_class.split(' ');

                        if (configurations.includes('custom-group')) {
                            customData.isCustomGroup = true;
                            customData.customGroupName = configurations[1].replace(/-/g, ' ');
                        }

                        if (configurations.includes('promotional')) {
                            customData.isPromotional = true;
                        }

                        if (!configurations.includes('promotional') && !configurations.includes('custom-group')) {
                            return this.renderSubLevelItems(item);
                        }

                        return null;
                    }) }
                    { customData.isPromotional && (
                    <div
                      block="Menu"
                      elem="SubItemWrapper"
                      mods={ { isPromotional: true } }
                    >
                        { childrenArray.map((item) => {
                            const configurations = item.item_class.split(' ');

                            if (configurations.includes('promotional')) {
                                return this.renderSubLevelItems(item);
                            }

                            return null;
                        }) }
                    </div>
                    ) }
                </div>
            </div>
        );
    }

    renderSubMenuDesktopItems = (item) => {
        const { item_id, children, show_subcategory_menu_images } = item;

        if (!Object.keys(children).length) {
            return null;
        }

        const { activeMenuItemsStack, closeMenu } = this.props;
        const isVisible = activeMenuItemsStack.includes(item_id);

        if (!isVisible) {
            return null;
        }

        return (
            <div
              block="Menu"
              elem="SubCategoriesWrapper"
              mods={ { isVisible } }
              key={ item_id }
              ref={ this.submenuWrapperRef }
            >
                <div
                  block="Menu"
                  elem="SubCategoriesWrapperInner"
                  mods={ { isVisible } }
                >
                    <div
                      block="Menu"
                      elem="SubCategories"
                      mods={ { isSlider: show_subcategory_menu_images } }
                    >
                        { this.renderSubLevel(item) }
                        { show_subcategory_menu_images && this.renderImagesContainer() }
                    </div>
                </div>
                <div
                  block="Menu"
                  elem="Overlay"
                  mods={ { isVisible } }
                  onMouseEnter={ closeMenu }
                />
            </div>
        );
    };

    renderSubMenuDesktop(itemList) {
        const childrenArray = getSortedItems(Object.values(itemList));

        return childrenArray.map(this.renderSubMenuDesktopItems);
    }

    renderFirstLevelItems(item) {
        const {
            activeMenuItemsStack,
            onCategoryHover,
            closeMenu,
            onCategoryClick,
            menu = {}
        } = this.props;

        const itemMods = { type: 'main' };
        const menuArray = Object.values(menu);
        const [{ children: topLevelItems = {} } = {}] = menuArray;

        return (
            <MenuItem
              activeMenuItemsStack={ activeMenuItemsStack }
              item={ item }
              itemMods={ itemMods }
              onCategoryHover={ onCategoryHover }
              onCategoryClick={ onCategoryClick }
              closeMenu={ closeMenu }
              isLink
              isParent
              isDeviceDesktop
              isSmall={ Object.values(topLevelItems)?.length >= 8 }
            />
        );
    }

    renderFirstLevel = (item) => {
        const { item_id, item_class } = item;
        const isHighlighted = item_class?.includes('highlight');

        return (
            <li
              key={ item_id }
              block="Menu"
              elem="Item"
              mods={ { isHighlighted } }
              onMouseEnter={ () => {
                  this.setState({ hoveredParent: item.item_id });
              } }
            >
                { this.renderFirstLevelItems(item) }
            </li>
        );
    };

    renderFirstLevelPlaceholder() {
        // eslint-disable-next-line no-magic-numbers
        const sizes = [6, 4, 4, 6, 11, 4];

        return sizes.map((item, index) => (
            <li
              // eslint-disable-next-line react/no-array-index-key
              key={ index }
              block="Menu"
              elem="Item"
            >
                <div block="Menu" elem="ItemName" mods={ { type: 'main' } }>
                    { 'A'.repeat(item) }
                </div>
            </li>
        ));
    }

    renderPlaceholder() {
        return (
            <div
              block="Menu"
              elem="MenuWrapperDesktop"
              mods={ { isLoading: true } }
            >
                <div
                  block="Menu"
                  elem="MainCategories"
                >
                    <ul
                      block="Menu"
                      elem="ItemList"
                    >
                        { this.renderFirstLevelPlaceholder() }
                    </ul>
                </div>
            </div>
        );
    }

    renderTopLevel() {
        const { menu, activeMenuItemsStack } = this.props;
        const categoryArray = Object.values(menu);
        const { hoveredParent } = this.state;

        if (!categoryArray.length) {
            return null;
        }

        const [{ children, title: mainCategoriesTitle }] = categoryArray;
        const childrenArray = getSortedItems(Object.values(children));

        return (
            <>
                <div
                  block="Menu"
                  elem="MainCategories"
                >
                    <ul
                      block="Menu"
                      elem="ItemList"
                      mods={ { type: 'main', isHovered: activeMenuItemsStack.length > 0 && !!hoveredParent } }
                      aria-label={ mainCategoriesTitle }
                    >
                        { childrenArray.map(this.renderFirstLevel) }
                    </ul>
                </div>
                { this.renderSubMenuDesktop(children) }
            </>
        );
    }

    render() {
        const { closeMenu, isLoading } = this.props;

        if (isLoading) {
            return this.renderPlaceholder();
        }

        return (
            <div
              block="Menu"
              elem="MenuWrapperDesktop"
              onMouseLeave={ () => {
                  closeMenu();
                  this.setState({ hoveredParent: undefined });
              } }
            >
                { this.renderTopLevel() }
            </div>
        );
    }
}

export default MenuComponent;
